<template>
  <div>
    <vs-table :data="notifications">

      <template slot="thead">
        <vs-th :class="{'float-right': title === $t('notifications.table.actions')}" :key="i" class="text-base"
               v-for="(title, i) in header">{{ title }}
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indexTr" class="" v-for="(tr, indexTr) in data">
          <vs-td :data="tr.title">
            <span :class="tr.is_read ? '' : 'font-bold'">{{ tr.title }}</span>
          </vs-td>
          <vs-td :data="tr.title">
            <span :class="tr.is_read ? '' : 'font-bold'">{{ tr.sent_at | date('MMM Do YYYY - HH:mm') }}</span>
          </vs-td>
          <vs-td class="text-right w-16">
            <div class="flex justify-end">
              <vx-tooltip :text="$t('notifications.details')" position="top">
                <base-button @click="$emit('notificationClicked', tr)" class="self-end px-3 mx-px" icon="arrow-right"/>
              </vx-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
  export default {
    name: 'NotificationsTable',
    components: {},
    props: {
      header: {
        type: Array,
        required: true
      },
      notifications: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
